/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OpportunityTypeResponse = {
    Open: 'OPEN',
    Sourcing: 'SOURCING'
} as const;
export type OpportunityTypeResponse = typeof OpportunityTypeResponse[keyof typeof OpportunityTypeResponse];


export function instanceOfOpportunityTypeResponse(value: any): boolean {
    for (const key in OpportunityTypeResponse) {
        if (Object.prototype.hasOwnProperty.call(OpportunityTypeResponse, key)) {
            // @ts-ignore
            if (OpportunityTypeResponse[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OpportunityTypeResponseFromJSON(json: any): OpportunityTypeResponse {
    return OpportunityTypeResponseFromJSONTyped(json, false);
}

export function OpportunityTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityTypeResponse {
    return json as OpportunityTypeResponse;
}

export function OpportunityTypeResponseToJSON(value?: OpportunityTypeResponse | null): any {
    return value as any;
}

